import { Component, OnInit, ElementRef, NgZone, PLATFORM_ID, Inject, Renderer2 } from '@angular/core';
//import { NetworkServicesService } from 'src/app/networkCalls/network-services.service';
import { Title, Meta } from '@angular/platform-browser';
// import { katanaInput } from 'src/app/models/katana-input.service';
// import { katanaResult } from 'src/app/models/katana-result.service';
// import { CKEditorComponent } from 'ngx-ckeditor';
import { isPlatformBrowser, DOCUMENT, isPlatformServer } from '@angular/common';
// import { FeedbackModalComponent } from 'src/app/Components/feedback-modal/feedback-modal.component';
// import { Observable, from } from 'rxjs';
// import { MatDialog } from '@angular/material';
// import { ErrorModalComponent } from '../error-modal/error-modal.component';
// import { ProgressStatusService } from '../../services/progress-status-service'
//import { rejectError } from 'src/app/models/reject-suggetions.service';
// import { NGXLogger } from 'ngx-logger';
//import { acceptError } from 'src/app/models/accept-suggetions.service';
//import { trigger, transition, style } from '@angular/animations';
// import { $ } from 'protractor';
import * as $ from 'jquery';
import { LinkService } from '../../_services/langhfre.service';
//import { MatRadioChange } from '@angular/material/radio';
//import { MatSnackBar } from '@angular/material/snack-bar';
//import { start } from 'repl';
// import { MatDialog } from '@angular/material/dialog';
// import { NoopScrollStrategy } from '@angular/cdk/overlay'
// import { DetectionLimitExhaustModalComponent } from '../detection-limit-exhaust-modal/detection-limit-exhaust-modal.component';
// import { EnglishGrammarCheckerComponent } from 'src/app/Components/english-grammar-checker/english-grammar-checker.component';
// import { environment } from 'src/environments/environment';
//declare function ire(string,{}): any;
@Component({
  selector: 'app-gc-editor',
  templateUrl: './gc-editor.component.html',
  styleUrls: ['./gc-editor.component.scss']
})
export class GcEditorComponent implements OnInit {
  
  constructor(
    private elRef: ElementRef,
    private titleService: Title,
    private metaTagService: Meta,
    private LinkService: LinkService,
    // public dialog: MatDialog,
    // public progressStatusService: ProgressStatusService,
    // private errorModalComponent: ErrorModalComponent,
    public lc: NgZone,
    @Inject(PLATFORM_ID) private platformId: Object,
    private _renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document,
    // private logger: NGXLogger,
  ) {
    //window.addEventListener("message", (d)=>{this.listenWindowMessage(d)});
  }


  ngOnInit() {
    // ele.classList.remove("loading")
    this.titleService.setTitle("Trinka的免费在线英语语法检查工具");
    this.metaTagService.updateTag({ name: 'description', content: "Trinka的免费在线英语语法检查工具可帮助您立即纠正写作、语法、以及拼写错误等。" });
    this.metaTagService.updateTag({ property: 'og:title', content: "Trinka的免费在线英语语法检查工具" });
    this.metaTagService.updateTag({ property: 'og:description', content: "Trinka的免费在线英语语法检查工具可帮助您立即纠正写作、语法、以及拼写错误等。" });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://trinka.enago.cn/grammar-checker' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://trinka.enago.cn/assets/images/Trinka.jpg' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://trinka.enago.cn/grammar-checker' });
    this.metaTagService.updateTag({ name: 'language', content: 'zh-cn' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/grammar-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/grammar-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/grammar-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/grammar-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/grammar-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/grammar-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/grammar-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/grammar-checker' });
    if (isPlatformBrowser(this.platformId)) {
      if ((navigator.userAgent.indexOf("Edg") != -1)) {
        $("#GCChromeButton").css("display", "none");
        $("#GCFirFoxButton").css("display", "none");
        $("#GCEdgeButton").css("display", "block");
        return 'Edge';
      }
      else if ((navigator.userAgent.indexOf("MSIE") != -1)) {
        $("#GCChromeButton").css("display", "none");
        $("#GCFirFoxButton").css("display", "none");
        $("#GCEdgeButton").css("display", "block");
        return 'IE';
      }
      else if ((navigator.userAgent.indexOf("Opera") || navigator.userAgent.indexOf('OPR')) != -1) {
        $("#GCChromeButton").css("display", "none");
        $("#GCFirFoxButton").css("display", "none");
        $("#GCEdgeButton").css("display", "none");
        return 'Opera';

      } else if (navigator.userAgent.indexOf("Chrome") != -1) {
        $("#GCChromeButton").css("display", "block");
        $("#GCFirFoxButton").css("display", "none");
        $("#GCEdgeButton").css("display", "none");
        return 'Chrome';

      } else if (navigator.userAgent.indexOf("Safari") != -1) {
        $("#GCChromeButton").css("display", "none");
        $("#GCFirFoxButton").css("display", "none");
        $("#GCEdgeButton").css("display", "none");

        return 'Safari';

      } else if (navigator.userAgent.indexOf("Firefox") != -1) {
        $("#GCChromeButton").css("display", "none");
        $("#GCFirFoxButton").css("display", "block");
        $("#GCEdgeButton").css("display", "none");
        return 'Firefox';

      }
      else {
        return 'unknown';
      }

    }

    //ire('identify', { 'customerId': '', customerEmail: '', customProfileId: '' });
  }

}
